import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { Whatsapp, Trash } from 'react-bootstrap-icons';
import './Node.css';

const SendWhatsAppNode = ({ data, id, outputEdges, onEdgeCountChange }) => {
  // Define edge labels
  //const edgeLabels = ['Send', 'Delivered', 'Read', 'Replied', 'Failed'];
  const edgeLabels = ['Send'];
 
  // Define color schemes based on source
  const getColorClasses = (source) => {
    switch (source) {
      case 'seller':
        return {
          container: 'custom-node node-rounded-full node-border-green',
          header: 'node-header node-bg-green-gradient node-border-green-bottom',
          text: 'node-text-green',
          handle: 'node-handle node-handle-green'
        };
      case 'manager':
        return {
          container: 'custom-node node-rounded-full node-border-purple',
          header: 'node-header node-bg-purple-gradient node-border-purple-bottom',
          text: 'node-text-purple',
          handle: 'node-handle node-handle-purple'
        };
      default: // actions
        return {
          container: 'custom-node node-rounded-lg node-border-green-light',
          header: 'node-header node-bg-green-gradient node-border-green-bottom',
          text: 'node-text-green',
          handle: 'node-handle node-handle-green-light'
        };
    }
  };

  const colors = getColorClasses(data.source || 'actions');

  // Add hover state
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <div 
      className={`${colors.container} node-hover-lift`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Updated delete button with hover visibility */}
      <div 
        className={`delete-btn ${data.source === 'seller' || data.source === 'manager' ? 'delete-btn.top-right' : 'delete-btn.top-center'} ${isHovered ? 'show' : ''}`}
        onClick={(e) => {
          e.stopPropagation();
          if (data.onDelete) {
            data.onDelete(id);
          }
        }}
      >
        <Trash className='icon-trash'/>
      </div>

      <div className={colors.header}>
        <div className="node-header-content">
          <Whatsapp className='node-icon' style={{ color: colors.text.includes('green') ? '#15803d' : colors.text.includes('purple') ? '#7c3aed' : '#15803d' }}/>
          {data?.label?.length > 0 ? "" : <span className={`node-title ${colors.text}`}>Send WhatsApp Message</span>}
          {data?.label?.length > 0 && <span className={`node-title ${colors.text}`}>{data.label}</span>}
        </div>
      </div>

      {(data.source === 'seller' || data.source === 'manager') ? (
        <>
          <Handle
            type="target"
            position={Position.Top}
            className={colors.handle}
          />
          {data.source !== 'manager' ? <Handle
            type="source"
            position={Position.Bottom}
            className={colors.handle}
          /> : null}
        </>
      ) : (
        <>
          <Handle
            type="target"
            position={Position.Left}
            className={colors.handle}
          />
         
          {outputEdges > 0 && (
            <div className="node-output-handles-vertical">
              {Array.from({ length: outputEdges }).map((_, index) => (
                <div 
                  key={`output-${index}`} 
                  className="node-relative node-w-full"
                  style={{
                    top: `${(index * 100) / (outputEdges - 1)}%`,
                    transform: 'translateY(-50%)'
                  }}
                >
                  <Handle
                    type="source"
                    position={Position.Right}
                    id={`output-${index}`}
                    className={colors.handle}
                  />
                  <div 
                    className={`node-edge-label ${colors.text} ${isHovered ? 'show' : ''}`}
                    style={{
                      left: 'calc(100% + 8px)',
                      right: 'auto',
                      top: '-6px',
                    }}
                  >
                    {edgeLabels[index]}
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default SendWhatsAppNode; 
